import { bulkEditionRow } from 'common/api/productsBulk';
import showToast from 'common/utils/showToast';

import {
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';
import * as selectors from '../selectors';

export default (values) => (dispatch, getState) => {
    const state = getState();
    const data = selectors.getItemsData(state);

    if (!values.id) return;

    const newValues = {
        code: values.code,
        name: values.name,
    };

    dispatch(actions[SAVE]());

    bulkEditionRow(newValues, values.id)
        .then(() => {
            dispatch(actions[SAVE_SUCCESS]());
            const newItems = data.map((item) =>
                item.id === values.id ? values : item,
            );
            dispatch(actions[UPDATE_ITEMS_SUCCESS](newItems));
            showToast();
        })
        .catch((error) =>
            dispatch(actions[SAVE_FAILURE](error?.response?.data?.errors)),
        );
};
